import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Breadcrumbs,
  Grid,
  Typography,
  Chip,
} from "@material-ui/core";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import HomeStyles from "pages/HomeStyles";
import {
  setCurrentPage,
  getPhotoShootMapDataNtt,
  setPictreeMapType,
} from "actions";
import * as C from "components";
import PhotoShootMapNtt from "components/PicTree/Game/Map/PhotoShootMapNtt";
import SingleSelect from "components/Select/SingleSelect";
import CalendarRangePicTreeNtt from "components/Calendar/CalendarRangePicTreeNtt";

const useStyles = makeStyles((theme) =>
  createStyles({
    loaderBox: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 280,
    },
    loaderBarImg: {
      width: 40,
    },
    breadcrumbs: {
      marginTop: 16,
      minHeight: 30,
    },
    gridSection: {
      marginTop: theme.spacing(1),
    },
  })
);

const PicTreeMapNtt = ({
  currentPage,
  setCurrentPage,
  pageTopLoader,
  photoShootMapData,
  getPhotoShootMapDataNtt,
  setPictreeMapType,
  dateRangePicTreeNtt,
  selectedSeasonNtt,
}) => {
  const classes = useStyles();
  const [chartSize, setChartSize] = useState({ name: "撮影ずみ", value: "taken" });
  const [photoType, setPhotoType] = useState("taken");
  const [initialDataCall, setInitialDataCall] = useState(false);
  const [singleSelectDisabled, setSingleSelectDisabled] = useState(false);
  const [mapData, setMapData] = useState([]);

  useEffect(() => {
    setCurrentPage(window.location.pathname);
  }, []);

  useEffect(() => {
    if (
      dateRangePicTreeNtt[0] !== null &&
      dateRangePicTreeNtt[1] !== null &&
      initialDataCall
    ) {
      getPhotoShootMapDataNtt({type: "denchu", filter: "taken"});
      setInitialDataCall(false);
    }
  }, [dateRangePicTreeNtt]);

  useEffect(() => {
    if (photoType === "taken") {
      //setMapData(photoShootMapData?.taken);
      setMapData(photoShootMapData);
    } else if (photoType === "untaken") {
      //setMapData(photoShootMapData?.untaken);
      setMapData(photoShootMapData);
    } else {
      const combinedData = [
        ...(photoShootMapData?.taken || []).map((item) => ({ ...item, status: "taken" })),
        ...(photoShootMapData?.untaken || []).map((item) => ({ ...item, status: "untaken" })),
      ];
      setMapData(combinedData);
    }
  }, [photoShootMapData]);

  const handleChange = (event) => {
    setChartSize(event.target);
    setPictreeMapType(event.target.value);
    setPhotoType(event.target.value);
    getPhotoShootMapDataNtt({type: "denchu", filter: event.target.value});
  };

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: -16, marginBottom: 8 }}
          justifyContent="space-between"
        >
          <Grid item>
            <Breadcrumbs separator="›" className={classes.breadcrumbs}>
              <Typography>PicTrée NTT</Typography>
              <Typography variant="body1">撮影</Typography>
              <Typography variant="body1">地図表示</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item className={classes.fillRemailSpace}></Grid>
          <Grid item>
            <CalendarRangePicTreeNtt
              mDate={"2024/12/7"}
              page="pictree-map"
              singlePeriod
            />
          </Grid>
        </Grid>

        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: 16, marginRight: 8, marginBottom: 8 }}
          justifyContent="flex-start"
        >
          <Grid item style={{ marginTop: 0, marginLeft: 8, }}>
            <SingleSelect
              selected={chartSize}
              options={[
                { name: `撮影済み`, value: "taken" },
                { name: `未撮影`, value: "untaken" },
                // { name: `撮影済み + 未撮影`, value: "both" },
              ]}
              handleChange={handleChange}
              disabled={singleSelectDisabled}
            />
          </Grid>
          {photoType !== "both" &&
          <>
            <Grid item>
              <Typography variant="subtitle1" style={{marginTop: 10, marginLeft: 16}}>
                {photoType === "taken" ? "撮影数：" : "未撮影数："}
                {mapData !== undefined && mapData.length > 0 && !pageTopLoader ? mapData.length : "--"}
              </Typography>
            </Grid>
            <Grid item style={{paddingTop: 18, marginLeft: 16}}>
              <Typography variant="caption">
                {photoType === "taken" ? "* %表示は撮影済み総数に占める割合です" : "* %表示は未撮影総数に占める割合です"}
              </Typography>
            </Grid>
          </>
          }
          {/* {photoType === "both" &&
          <>
          <Grid item>
            <Typography variant="subtitle1" style={{marginTop: 10, marginLeft: 16}}>
              撮影数：
              {mapData !== undefined && mapData.length > 0 && !pageTopLoader ? photoShootMapData?.taken.length : "--"}
            </Typography>
          </Grid>
          <Grid item>
           <Typography variant="subtitle1" style={{marginTop: 10, marginLeft: 16}}>
             未撮影数:
             {mapData !== undefined && mapData.length > 0 && !pageTopLoader ? photoShootMapData?.untaken.length : "--"}
           </Typography>
          </Grid></>
          } */}
        </Grid>

        {mapData.length > 0 &&
          <PhotoShootMapNtt
            records={mapData}
            type="photoshoot"
            width="100%"
            height="85vh"
            status={chartSize === undefined ? "taken" : chartSize.value}
            seasonId={
              selectedSeasonNtt.length > 0
                ? selectedSeasonNtt[0]["seasonId"]
                : false
            }
            photoShootMapData={photoShootMapData}
          />
        }
        {mapData.length == 0 &&
          <PhotoShootMapNtt
            records={[]}
            type="photoshoot"
            width="100%"
            height="85vh"
            status="taken"
            seasonId={
              selectedSeasonNtt.length > 0
                ? selectedSeasonNtt[0]["seasonId"]
                : false
            }
            photoShootMapData={photoShootMapData}
          />
        }
      </C.ContentWrapper>
    </Fragment>
  );
};

PicTreeMapNtt.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  currentPage: state.page.currentPage,
  pageTopLoader: state.page.pageTopLoader,
  photoShootMapData: state.pictreeNtt.photoShootMapData,
  dateRangePicTreeNtt: state.page.dateRangePicTreeNtt,
  selectedSeasonNtt: state.pictreeNtt.selectedSeason,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getPhotoShootMapDataNtt: (param) => dispatch(getPhotoShootMapDataNtt(param)),
  setPictreeMapType: (param) => dispatch(setPictreeMapType(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(HomeStyles, { withTheme: true })(PicTreeMapNtt));
